import { Text } from '@doist/marketist';
function ProductUITypingIndicator() {
  return <Text tag="span" size="major-sm" weight="semibold" style={{
    color: 'var(--productui-primary-theme-color)'
  }} data-sentry-element="Text" data-sentry-component="ProductUITypingIndicator" data-sentry-source-file="product-ui-typing-indicator.tsx">
            |
        </Text>;
}
export { ProductUITypingIndicator };